export default "__VITE_ASSET__C6pTdQ$K__"